import React from 'react';

export const inputCls =
  'w-full px-3 py-2.5 rounded-lg border border-input bg-background text-sm focus:outline-none focus:ring-2 focus:ring-[hsl(var(--gold))] transition-shadow';

export const AuthLayout = ({ title, subtitle, children, footer, testid }) => (
  <div className="min-h-[70vh] flex items-center justify-center px-4 py-12" data-testid={testid}>
    <div className="w-full max-w-md">
      <div className="text-center mb-6">
        <div className="w-12 h-12 bg-[hsl(var(--gold))] rounded-xl flex items-center justify-center mx-auto mb-4">
          <span className="text-[hsl(var(--accent-foreground))] font-heading font-bold text-lg">İ</span>
        </div>
        <h1 className="font-heading text-2xl font-semibold">{title}</h1>
        {subtitle && <p className="text-sm text-muted-foreground mt-1">{subtitle}</p>}
      </div>
      <div className="p-6 rounded-2xl bg-card border border-border shadow-[var(--shadow-elev-1)]">{children}</div>
      {footer && <div className="text-center mt-4 text-sm text-muted-foreground">{footer}</div>}
    </div>
  </div>
);
